import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { AuthCard } from '../components/AuthCard';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { Alert } from '../components/Alert';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    setLoading(true);
    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (resetError) {
        setError(resetError.message);
        setLoading(false);
        return;
      }

      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unexpected error occurred');
      setLoading(false);
    }
  }

  return (
    <AuthCard title="Reset your password" subtitle="We'll send you a link to reset it">
      {error && <Alert variant="error" message={error} onDismiss={() => setError(null)} />}

      {success ? (
        <>
          <Alert variant="success" message="Check your email for the reset link." />
          <p className="text-center text-sm text-ll-muted mt-4">
            <Link to="/sign-in" className="text-ll-cyan hover:brightness-110 transition-colors">
              Back to sign in
            </Link>
          </p>
        </>
      ) : (
        <form onSubmit={handleSubmit}>
          <Input
            label="Email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={setEmail}
            autoComplete="email"
            required
            disabled={loading}
          />

          <Button type="submit" loading={loading}>
            Send reset link
          </Button>

          <p className="text-center text-sm text-ll-muted mt-6">
            <Link to="/sign-in" className="text-ll-cyan hover:brightness-110 transition-colors">
              Back to sign in
            </Link>
          </p>
        </form>
      )}
    </AuthCard>
  );
}
